<template>
  <v-row align="center" justify="center" class="showcase">
    <v-col cols="12" md="6" class="d-flex justify-center">
      <div class="vitrine-shot">
        <img
          :src="require('@/assets/images/tablet-vitrine.webp')"
          class="vitrine-img"
          alt="Cliente à mesa tocando o tablet de autoatendimento com o cardápio de pizzas do ZaperMenu"
          width="1000"
          height="1000"
          loading="lazy"
          decoding="async"
        />

        <div class="vitrine-tag">
          <span class="vitrine-dot"></span>Em destaque agora
        </div>
      </div>
    </v-col>

    <v-col cols="12" md="6">
      <div class="hero-badge">
        <v-icon small class="mr-1" color="error">mdi-monitor-shimmer</v-icon>
        Outdoor na mesa
      </div>

      <SectionTitle class="mt-3">Cardápio Digital que aumenta as vendas</SectionTitle>

      <p class="section-desc mt-4">
        É o seu melhor vendedor trabalhando em cada mesa, o tempo todo. O tablet mostra fotos, destaques e promoções que
        dão água na boca.
      </p>

      <div class="feature-list mt-6">
        <div v-for="(item, i) in features" :key="i" class="feature-item">
          <div class="feature-icon-wrap">
            <v-icon size="20" color="error">{{ item.icon }}</v-icon>
          </div>
          <span>{{ item.text }}</span>
        </div>
      </div>

      <div class="mt-7">
        <CtaButton>Quero vender mais</CtaButton>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import SectionTitle from '@/components/SectionTitle.vue';
  import CtaButton from '@/components/CtaButton.vue';

  export default {
    name: 'TabletShowcaseSection',

    components: {
      SectionTitle,
      CtaButton,
    },

    data: () => ({
      features: [
        { icon: 'mdi-image-multiple', text: 'Fotos grandes que estimulam o consumo' },
        { icon: 'mdi-sale', text: 'Destaques e promoções rotativos' },
        { icon: 'mdi-food-variant', text: 'Combos e adicionais sugeridos na hora' },
      ],
    }),
  };
</script>

<style scoped lang="scss">
  .showcase {
    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 999px;
    border: 1px solid rgba(244, 6, 18, 0.35);
    background: rgba(244, 6, 18, 0.08);
    font-size: 13px;
    font-weight: 600;
    color: #f40612;
    letter-spacing: 0.02em;
  }

  .section-desc {
    font-size: 16px;
    line-height: 1.7;
    color: var(--text-secondary);
    margin: 0;
    max-width: 480px;
  }

  .feature-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .feature-item {
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 15px;
    color: var(--text-secondary);
  }

  .feature-icon-wrap {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: rgba(244, 6, 18, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .vitrine-shot {
    position: relative;
    width: 100%;
    max-width: 460px;
  }

  .vitrine-img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 18px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
  }

  .vitrine-tag {
    position: absolute;
    top: 12px;
    left: 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 11px;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.72);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    backdrop-filter: blur(4px);
  }

  .vitrine-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #23cf65;
    box-shadow: 0 0 0 0 rgba(35, 207, 101, 0.7);
    animation: vitrine-pulse 1.8s infinite;
  }

  @keyframes vitrine-pulse {
    0%   { box-shadow: 0 0 0 0 rgba(35, 207, 101, 0.7); }
    70%  { box-shadow: 0 0 0 8px rgba(35, 207, 101, 0); }
    100% { box-shadow: 0 0 0 0 rgba(35, 207, 101, 0); }
  }
</style>
